/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesFAQContent,
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';
import { propTypesPost } from '../Post/Post.proptypes';

export const propTypesCategory = {
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    breadcrumb_title: PropTypes.string,
    faq_content: PropTypes.arrayOf(PropTypes.shape(propTypesFAQContent)),
    category_color: PropTypes.string,
    category_name: PropTypes.string,
    description: PropTypes.string,
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    promo_card_label: PropTypes.string,
    promo_card_link: PropTypes.shape(propTypesLink),
    promo_card_title: PropTypes.string,
    title: PropTypes.shape(propTypesTextHtml),
  }),
  first_publication_date: PropTypes.string,
  highlight_category: PropTypes.shape({
    document: PropTypes.shape(propTypesCategory),
    slug: PropTypes.string,
  }),
  highlight_posts_title: PropTypes.string,
  highlight_posts: PropTypes.arrayOf(
    PropTypes.shape({
      hightlight_post: PropTypes.shape(propTypesPost),
    })
  ),
  id: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  url: PropTypes.string,
};
